import React from "react";
import { MicroCourse } from "../../../modules/academy/models";

export interface MicroCourseCardProps {
  microCourse: MicroCourse;
  isCompleted: boolean;
  isInProgress: boolean;
  isGuest: boolean;
  isKid?: boolean;
  onStart?: () => void;
  onMarkCompleted?: () => void;
}

export function MicroCourseCard({
  microCourse,
  isCompleted,
  isInProgress,
  isGuest,
  isKid,
  onStart,
  onMarkCompleted,
}: MicroCourseCardProps) {
  const { title, duration, difficulty, audience } = microCourse;
  return (
    <div className="mm-surface p-4 space-y-2">
      <div className="flex items-center justify-between">
        <h3 className="text-base font-semibold">{title}</h3>
        {isCompleted && (
          <span className="text-[11px] px-2 py-0.5 rounded-full bg-emerald-500/10 text-emerald-600 border border-emerald-500/30">
            Termine
          </span>
        )}
      </div>
      {!isKid && (
        <p className="text-xs text-slate-500 dark:text-slate-400">
          {duration ? `${duration} min` : "Duree libre"} · {difficulty ? `Difficulte: ${difficulty}` : "Difficulte libre"} ·{" "}
          {audience || "public"}
        </p>
      )}
      {isGuest && (
        <p className="text-[11px] text-slate-500 dark:text-slate-400">
          Connectez-vous pour sauvegarder votre progression.
        </p>
      )}
      <div className="flex gap-2">
        <button
          type="button"
          className="px-3 py-1.5 rounded-lg bg-blue-600 text-white text-sm font-semibold hover:bg-blue-700"
          onClick={onStart}
        >
          {isCompleted ? "Relire" : isInProgress ? "Continuer" : "Commencer"}
        </button>
        <button
          type="button"
          className="px-3 py-1.5 rounded-lg border text-sm font-semibold bg-white dark:bg-slate-900 dark:border-slate-700"
          onClick={onMarkCompleted}
          disabled={isGuest}
        >
          Continuer
        </button>
      </div>
    </div>
  );
}
